<div class="hc-table-bulk-actions cdp-grid-bulk-actions" *ngIf="!hideRowCount">
    <ng-template *ngTemplateOutlet="selectAllMsg"></ng-template>
    <span class="selected-count" title="Select rows to perform bulk actions">
        ({{ selectedRowCount }} row{{ selectedRowCount === 1 ? '' : 's' }} selected{{
            selectedRowsHidden > 0 ? ', ' + selectedRowsHidden + ' hidden' : ''
        }})
    </span>

    <ng-container *ngIf="selectedRowCount > 0">
        <ng-content></ng-content>
    </ng-container>
</div>

<!-- Allows for showing the select all msg without the row count, if desired-->
<div *ngIf="hideRowCount && presentSelectAllPagesOption" class="hc-table-bulk-actions cdp-grid-bulk-actions">
    <ng-template *ngTemplateOutlet="selectAllMsg"></ng-template>
</div>

<!-- Template for 'Select all' msg-->
<ng-template #selectAllMsg>
    <span *ngIf="presentSelectAllPagesOption" class="select-all-pages-msg selected-count">
        All {{ dataSource?.paginator.pageSize }} rows on this page are selected.
        <a hc-button buttonStyle="link-inline" (click)="toggleAllSelectItems(true)" title="Select all rows on all pages"
            >Select all {{ dataSource.filteredData.length }} rows.</a
        >
    </span>
</ng-template>
